export enum PrivacySettingsMessage {
  DisplayMyChatRooms = 'Display My Chat Rooms to Other Users',
  DisplayMyTextChannels = 'Display My Text Channels to Other Users',
  DisplayWhoIFollow = 'Display Who I’m Following to Other Users',
  DisplayWhoFollowsMe = 'Display Who Follows Me to Other Users',
  DisplayMyAwards = 'Display My Awards to Other Users',
  DisplayMyNFTs = 'Display My NFTs to Other Users',
  DisplayMyTotalReceivedLikesAndViews = 'Display My Total Received Likes & Views to Other Users',
  DisplayAvailabilityToCollaborate = 'Display That I’m Available to Collaborate with Other Creators',
  DisplayInCreatorDirectory = 'Display Me in the Creator Directory and Suggest Me to Other Users',
  OnlySubscribersAccessChatRoom = 'Only Allow Subscribers to Participate in my Chat Room',
  OnlySubscribersCommentOnPosts = 'Only Allow Subscribers to Comment on my Posts',
  MakeMyAccountPrivate = 'Make My Account Private',
  OnlyAllowFollowers = 'Only Allow My TopFan Followers to Access My Content',
  EnableWaterMarksOnPhotosVideos = 'Enable Watermarks on Photos',
  EnableWaterMarkInfo = 'You can enable a small gray watermark in your photos, videos or reels, to help protect people from stealing and reposting your content without your permission.',
  DisplayContentPostTimeStamps = 'Display Content Post Timestamps',
  DisplayMyGeneralLocationOnHomeScreen = 'Display My General Location on Home Screen',
}

export enum LOCATIONS {
  DIAGONAL = 'diagonal',
  TOP_LEFT = 'topLeft',
  TOP_RIGHT = 'topRight',
  BOTTOM_LEFT = 'bottomLeft',
  BOTTOM_RIGHT = 'bottomRight',
}

export const IMAGES_LOCATION_OPTIONS = [
  {label: 'Diagonal', value: LOCATIONS.DIAGONAL},
  {label: 'Bottom Right', value: LOCATIONS.BOTTOM_RIGHT},
]

export const VIDEO_REEL_LOCATION_OPTIONS = [
  {label: 'Top Left', value: LOCATIONS.TOP_LEFT},
  {label: 'Top Right', value: LOCATIONS.TOP_RIGHT},
  {label: 'Bottom Left', value: LOCATIONS.BOTTOM_LEFT},
  {label: 'Bottom Right', value: LOCATIONS.BOTTOM_RIGHT},
]

export enum WaterMarkMessageSetting {
  WaterMarkForPhotoLabel = 'My Photos',
  WaterMarkForVideoLabel = 'My Videos & Reels',
  WaterMarkTextLabel = 'Add Watermark Text',
  PoweredByTopFans = 'topfan.com',
  WaterMarkConfirmButton = 'Ok',
  WaterMarkCancelButton = 'Cancel',
  WaterMarkAddHeader = 'Enable Watermark'
}

export enum Subscription {
  ONLY_SUBSCRIBER_CAN_COMMENT_ON_POST = 'only_subscriber_can_comment_on_post',
  ONLY_SUBSCRIBER_CAN_ACCESS_CHATROOM = 'only_subscriber_can_access_chatroom',
  ENABLE_WATERMARKS_ON_PHOTOS_VIDEOS = 'enable_watermarks_on_photos_videos',
  YOU_DOES_NOT_HAVE_ANY_ACTIVE_SUBSCRIPTION = 'You does not have any active subscription '
}
export enum PrivacyKeys {
  ONLY_FOLLOWERS_CAN_ACCESS_CONTENT = 'only_followers_can_access_content',
  IS_PRIVATE = 'is_private'
}
